import rewardMenuReward from '../assets/reward-menu-reward.png'
import rewardMenuReward2x from '../assets/reward-menu-reward@2x.png'
import type { RewardMenuIconProps } from './RewardMenuIcon.types'

/**
 * Reward entry icon of the "Motivieren" menu (Figma 3324-43990).
 *
 * A rendered 3D emoji, so it ships as a raster asset with an @2x variant —
 * same pattern as OnboardingPauseAndRewardIcon. Decorative: the menu label
 * carries the meaning, so `alt` stays empty.
 *
 * @example
 * <RewardMenuRewardIcon className="reward-dropdown__icon" />
 */
export const RewardMenuRewardIcon = ({ size = 28, className }: RewardMenuIconProps) => (
  <img
    src={rewardMenuReward}
    srcSet={`${rewardMenuReward} 1x, ${rewardMenuReward2x} 2x`}
    alt=""
    aria-hidden
    className={className}
    width={size}
    height={size}
  />
)
